import { CustomBottomBar } from '@components';
import { Button, Checkbox, Container, Input, Typography } from '@design-system';
import React from 'react';
import './CarteBtpPage.scss';
import { useCarteBtpPageVM } from './useCarteBtpPageVM';

export const CarteBtpPage: React.FC = () => {
    const {
        location,
        setLocation,
        user,
        date,
        checked,
        setChecked,
        signature,
        setSignature,
        isFilled,
        errorMessage,
        handleCreateBtpCardDelivery
    } = useCarteBtpPageVM();

    if (!user) {
        return null;
    }

    return (
        <div className="carte-btp-page">
            <Container>
                <Typography intrinsic="h2" defaultSpacing>
                    Attestation de remise de la carte BTP
                </Typography>

                <Container className="carte-btp-container" padding="medium-large-spacing large-spacing" bordered="grey">
                    <Typography intrinsic="p" color="marine" className="carte-btp-text">
                        Je soussigné(e){' '}
                        <span className="carte-btp-text-name">
                            {user.first_name} {user.last_name}
                        </span>{' '}
                        atteste avoir reçu ma carte BTP.
                    </Typography>

                    <Typography intrinsic="p" variant="secondary" color="grey">
                        En cas de perte ou de vol, je m'engage à le signaler immédiatement à ma direction, le plus tôt possible.
                    </Typography>
                </Container>

                <Container className="carte-btp-container" bordered="grey" padding="medium-large-spacing large-spacing">
                    <Typography intrinsic="p" color="marine">
                        Fait à
                    </Typography>

                    <Input placeholder="Ville" value={location} onValueChange={setLocation} />

                    <Typography intrinsic="p" color="marine">
                        Le {date}
                    </Typography>
                    <Checkbox label="Je certifie que la carte BTP m'a été remise" checked={checked} onChange={() => setChecked(!checked)} />
                    <Checkbox
                        label="En cochant cette case, j'appose ma signature sur le présent document"
                        checked={signature}
                        onChange={() => setSignature(!signature)}
                    />
                </Container>
            </Container>

            {errorMessage && (
                <Typography intrinsic="p" color="red">
                    {errorMessage}
                </Typography>
            )}

            <CustomBottomBar>
                <Button color="marine" variant="primary" size="fullwidth" onClick={handleCreateBtpCardDelivery} disabled={!isFilled}>
                    <Typography intrinsic="h4">Envoyer mon attestation</Typography>
                </Button>
            </CustomBottomBar>
        </div>
    );
};
